import type { BmInstructionsRootStateType } from "./features/bmInstructionsSlice";
import type { bmInstructionExchangeApi } from "./features/bmInstructionsSlice/services/bmInstructionExchangeApi";
import type { faultExchangeApi } from "./features/faultExchangeSlice/services/faultExchangeApi";
import type { PortfolioExplorerRootStateType } from "./features/portfolioExplorerSlice";
import type { ScheduleExchangeRootStateType } from "./features/powerRootSlice";
import type { blockInputApi } from "./features/powerRootSlice/services/blockInputApi";
import type { createBlockScheduleApi } from "./features/powerRootSlice/services/createBlockScheduleApi";
import type { createPowerScheduleApi } from "./features/powerRootSlice/services/createScheduleApi";
import type { schedulePowerApi } from "./features/powerRootSlice/services/powerApi";
import type { ScheduleEnergyRootStateType } from "./features/scheduleEnergyRootSlice";
import type { energyExchangeApi } from "./features/scheduleEnergyRootSlice/services/energyExchangeApi";
import type { energyScheduleExchangeApi } from "./features/scheduleEnergyRootSlice/services/energyScheduleExchangeApi";
import type { entityExchangeApi } from "./features/scheduleEnergyRootSlice/services/entityExchangeApi";
import type { profileCreatorApi } from "./features/scheduleEnergyRootSlice/services/profileCreatorApi";
import type { TradeHubRootStateType } from "./features/tradeHubSlice";

export const dynamicSlicesNamesKeys = {
  POWER: "POWER",
  PORTFOLIO_EXPLORER: "PORTFOLIO_EXPLORER",
  SCHEDULE_ENERGY: "SCHEDULE_ENERGY",
  BM_INSTRUCTIONS: "BM_INSTRUCTIONS",
  TRADE_HUB: "TRADE_HUB",
} as const;

// used to map the dynamic slices to the reducer path
export const dynamicSlicesNames = {
  [dynamicSlicesNamesKeys.POWER]: "power",
  [dynamicSlicesNamesKeys.PORTFOLIO_EXPLORER]: "portfolioExplorer",
  [dynamicSlicesNamesKeys.SCHEDULE_ENERGY]: "scheduleEnergy",
  [dynamicSlicesNamesKeys.BM_INSTRUCTIONS]: "bmInstructions",
  [dynamicSlicesNamesKeys.TRADE_HUB]: "tradeHub",
} as const;

export type DynamicSlicesNames = typeof dynamicSlicesNames;

type RtkQueryApis = {
  [schedulePowerApi.reducerPath]: ReturnType<typeof schedulePowerApi.reducer>;
  [createPowerScheduleApi.reducerPath]: ReturnType<
    typeof createPowerScheduleApi.reducer
  >;
  [createBlockScheduleApi.reducerPath]: ReturnType<
    typeof createBlockScheduleApi.reducer
  >;
  //TODO: Remove this once block input is removed
  [blockInputApi.reducerPath]: ReturnType<typeof blockInputApi.reducer>;
  [bmInstructionExchangeApi.reducerPath]: ReturnType<
    typeof bmInstructionExchangeApi.reducer
  >;
  [energyExchangeApi.reducerPath]: ReturnType<typeof energyExchangeApi.reducer>;
  [entityExchangeApi.reducerPath]: ReturnType<typeof entityExchangeApi.reducer>;
  [profileCreatorApi.reducerPath]: ReturnType<typeof profileCreatorApi.reducer>;
  [energyScheduleExchangeApi.reducerPath]: ReturnType<
    typeof energyScheduleExchangeApi.reducer
  >;
  [faultExchangeApi.reducerPath]: ReturnType<typeof faultExchangeApi.reducer>;
};

export type LazyLoadedSlices = {
  // Regular slices
  [dynamicSlicesNames.POWER]: ScheduleExchangeRootStateType;
  [dynamicSlicesNames.SCHEDULE_ENERGY]: ScheduleEnergyRootStateType;
  [dynamicSlicesNames.BM_INSTRUCTIONS]: BmInstructionsRootStateType;
  [dynamicSlicesNames.PORTFOLIO_EXPLORER]: PortfolioExplorerRootStateType;
  [dynamicSlicesNames.TRADE_HUB]: TradeHubRootStateType;
} & RtkQueryApis;
